import {PropsWithChildren} from "react";
import {CreateProductProvider} from ".";

export function CreateProductContextWrapper({children}: PropsWithChildren) {
  return <CreateProductProvider>{children}</CreateProductProvider>;
}
